import PropTypes from 'prop-types';

function UnauthenticatedContent({ children, isAuthenticated }) {
  return !isAuthenticated ? children : null;
}

UnauthenticatedContent.propTypes = {
  children: PropTypes.any,
  isAuthenticated: PropTypes.bool,
};

export default UnauthenticatedContent;
